import React, { useMemo } from 'react';

import utils from 'utils';

const Bage = ({ user }) => {
  const { qc_full_group: qcFullGroup } = user;

  const percent = useMemo(() => {
    const { topPercent, standardPercent } = utils.getWriterBonusPercent(user);

    if (qcFullGroup === 'A-pro') {
      return `+${standardPercent}`;
    } else if (qcFullGroup === 'A+-pro') {
      return `+${topPercent}`;
    }

    return '0%';
  }, [qcFullGroup, user]);

  return (<span className="bage-pro">{percent}</span>);
};

export default Bage;
